export default function Mood({ value, onChange }) {
  const moods = [
    { key: "morning", label: "Ujutru", emoji: "🌅" },
    { key: "day", label: "Popodne", emoji: "☀️" },
    { key: "evening", label: "Uveče", emoji: "🌙" }
  ];

  const moodEmojis = ["😢", "😕", "😐", "🙂", "😄"];

  const handleChange = (key, newValue) => {
    onChange({
      ...value,
      [key]: newValue
    });
  };

  return (
    <div>
      <h3>😊 Raspoloženje</h3>

      {moods.map((mood) => (
        <div key={mood.key} className="mood-row">
          <span className="mood-label">{mood.emoji} {mood.label}</span>
          <div className="mood-buttons">
            {[1, 2, 3, 4, 5].map((num) => (
              <button
                key={num}
                type="button"
                className={`mood-btn ${value[mood.key] === num ? "active" : ""}`}
                onClick={() => handleChange(mood.key, num)}
              >
                {moodEmojis[num - 1]}
              </button>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
